import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface PopularRankProps {
  movies: Movie[];
}

export default function PopularRank({ movies }: PopularRankProps) {
  const max = Math.max(...movies.map((m) => m.popularity));

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-2 md:p-3">
      {movies.map((movie, i) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex items-center gap-4 rounded-md p-3 transition-colors hover:bg-background-100 cursor-pointer"
        >
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-display text-base font-bold ${
              i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
            }`}
          >
            {i + 1}
          </span>
          <div className="h-16 w-11 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={movie.poster}
              alt={`${movie.title}海报`}
              title={`${movie.title} - 激情视频`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
              {movie.title}
            </h3>
            <p className="mt-1 truncate text-xs text-foreground-500">
              {movie.cast.slice(0, 2).join(" / ")} · {movie.year}
            </p>
            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
              <div
                className="h-full rounded-full bg-primary-500"
                style={{ width: `${Math.round((movie.popularity / max) * 100)}%` }}
              />
            </div>
          </div>
          <span className="hidden shrink-0 font-display text-sm font-semibold text-foreground-600 sm:block">
            {movie.rating.toFixed(1)}
          </span>
        </Link>
      ))}
    </div>
  );
}